import { FC, useState, useEffect, ReactNode } from 'react';
import { ProRadio } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { RadioGroupProps } from 'antd/lib/radio';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { renderEnumNames, renderEnumName } from '../utils/renderUtils';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';

export interface SearchFormRadioGroupProps extends BaseSearchFormItemProps {
  /** radioGroup Props */
  radioGroupProps?: RadioGroupProps;
  /** 枚举名称 */
  enumCode?: string;
}
/** 单选按钮组 */
export const SearchFormRadioGroup: FC<SearchFormRadioGroupProps> = props => {
  const {
    radioGroupProps,
    isDetail,
    form,
    enumCode,
    isTable,
    testId,
    name,
    label,
    hideLabel,
    render,
    disabledRender,
    ...resProps
  } = props;
  const [options, setOptions] = useState<any[]>(radioGroupProps?.options || []);
  const { enumData } = useLayoutContext();
  useEffect(() => {
    if (enumCode && enumData) {
      setOptions(enumData[enumCode] ? enumData[enumCode].items || [] : []);
    }
  }, ['enumCode']);
  const renderText = (): ReactNode => {
    // @ts-ignore
    const groupVal = form?.getFieldValue?.(name) || radioGroupProps?.value;
    if (!groupVal || !options.length) return TABLE_COLUMN_EMPTY;
    if (Array.isArray(groupVal)) {
      return renderEnumNames(groupVal, options, '，');
    }
    return groupVal ? renderEnumName(groupVal, options) : TABLE_COLUMN_EMPTY;
  };
  return (
    <SearchFormItem
      {...resProps}
      name={name}
      test-id={`${testId}-${name}`}
      label={!hideLabel && label}
    >
      {isDetail || (radioGroupProps && radioGroupProps.disabled) ? (
        <SearchFormDisabled form={form} render={render || disabledRender || renderText} isTable={isTable} />
      ) : (
        <ProRadio.Group
          options={options}
          optionType="button"
          buttonStyle="solid"
          {...radioGroupProps}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormRadioGroup.displayName = SearchFormItemEnum.SearchFormRadioGroup;

export default SearchFormRadioGroup;
